import React from 'react';
import MathText from '../components/MathText';
import {
    appealEventLabels,
    appealReasonLabels,
    appealScopeLabels,
    appealStatusLabels,
    formatFeedbackDate,
} from './examFeedbackUtils';

const value = (input) => input === null || input === undefined || input === '' ? '—' : input;

export default function AppealDetails({appeal}) {
    if (!appeal) return null;
    const snapshot = appeal.snapshot || {};
    const answer = snapshot.answer;
    const decision = appeal.decision_snapshot || {};
    const finalStatus = ['accepted', 'partially_accepted', 'rejected', 'withdrawn'].includes(appeal.status);
    const activeStep = finalStatus ? 2 : appeal.status === 'under_review' ? 1 : 0;
    const steps = [
        {label: 'ثبت‌شده', detail: formatFeedbackDate(appeal.submitted_at)},
        {label: 'در حال بررسی', detail: appeal.review_started_at ? formatFeedbackDate(appeal.review_started_at) : 'در انتظار استاد'},
        {label: finalStatus ? (appealStatusLabels[appeal.status] || appeal.status) : 'تصمیم نهایی', detail: appeal.resolved_at ? formatFeedbackDate(appeal.resolved_at) : '—'},
    ];
    return <div className="ef-appeal-detail">
        <ol className="ef-appeal-stepper" aria-label="مراحل رسیدگی به اعتراض">{steps.map((step, index) => <li key={step.label} className={index < activeStep ? 'done' : index === activeStep ? 'current' : ''}><span>{index < activeStep ? '✓' : index + 1}</span><div><strong>{step.label}</strong><small>{step.detail}</small></div></li>)}</ol>
        <div className="ef-detail-grid">
            <div><small>وضعیت</small><strong className={`ef-status ${appeal.status}`}>{appealStatusLabels[appeal.status] || appeal.status}</strong></div>
            <div><small>نوع اعتراض</small><strong>{appealScopeLabels[appeal.scope] || appeal.scope}</strong></div>
            <div><small>دلیل</small><strong>{appealReasonLabels[appeal.reason] || appeal.reason}</strong></div>
            <div><small>تاریخ ثبت</small><strong>{formatFeedbackDate(appeal.submitted_at)}</strong></div>
            <div><small>آزمون</small><strong>{snapshot.exam_title || `آزمون ${appeal.exam_id}`}</strong></div>
            <div><small>تلاش</small><strong>{value(snapshot.attempt_number)}</strong></div>
        </div>
        <section className="ef-note"><small>شرح اعتراض</small><p>{appeal.description || '—'}</p></section>
        {answer && <section className="ef-snapshot">
            <header><h4>نسخه تاریخی پاسخ</h4><span>سؤال {value(answer.position)}</span></header>
            <h3><MathText text={answer.prompt}/></h3>
            <div className="ef-answer-columns">
                <div><small>پاسخ دانشجو</small><p><MathText text={answer.student_answer || 'بدون پاسخ'}/></p></div>
                <div><small>پاسخ معیار</small><p><MathText text={answer.reference_answer || '—'}/></p></div>
            </div>
            <p className="ef-grade-line">نمره هنگام ثبت: <b>{value(answer.awarded_points)}</b> از <b>{value(answer.question_points)}</b></p>
            {answer.teacher_feedback && <p><b>بازخورد اولیه استاد:</b> <MathText text={answer.teacher_feedback}/></p>}
        </section>}
        {(appeal.decision_note || Object.keys(decision).length > 0) && <section className="ef-decision">
            <h4>نتیجه رسیدگی</h4>
            {appeal.decision_note && <p>{appeal.decision_note}</p>}
            {Object.keys(decision).length > 0 && <div>
                <span>نمره قبلی: <b>{value(decision.previous_awarded_points)}</b></span>
                <span>نمره جدید: <b>{value(decision.new_awarded_points)}</b></span>
                <span>نمره کل تلاش: <b>{value(decision.attempt_score)}</b></span>
            </div>}
        </section>}
        <section className="ef-timeline">
            <h4>تاریخچه پرونده</h4>
            {(appeal.events || []).map((event) => <article key={event.id}>
                <i aria-hidden="true"/>
                <div><strong>{appealEventLabels[event.event_type] || event.event_type}</strong><p>{event.note || `${appealStatusLabels[event.from_status] || event.from_status || '—'} ← ${appealStatusLabels[event.to_status] || event.to_status || '—'}`}</p><small>{event.actor?.full_name || 'سامانه'} · {formatFeedbackDate(event.created_at)}</small></div>
            </article>)}
            {!appeal.events?.length && <p className="ef-empty">رویدادی ثبت نشده است.</p>}
        </section>
    </div>;
}

